import axios from "axios";

/* ============================================================
   🔧 BASE AXIOS INSTANCE — SIMPLE JWT MODE (STABLE)
============================================================ */
const instance = axios.create({
  baseURL:
    process.env.REACT_APP_API_BASE_URL ||
    "https://store-backend-main-jiatelier-production.up.railway.app/api",
    // "http://localhost:5001/api",
  timeout: 30000,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

/* ============================================================
   🔐 REQUEST INTERCEPTOR → ATTACH ACCESS TOKEN
============================================================ */
instance.interceptors.request.use((config) => {
  const token = localStorage.getItem("accessToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

/* ============================================================
   🔐 RESPONSE INTERCEPTOR → HANDLE 401 (EXPIRED/INVALID TOKEN)
============================================================ */
instance.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      const url = err.config?.url || "";
      const isAuthRoute = /\/auth\/(login|register)/.test(url);
      if (!isAuthRoute) {
        localStorage.removeItem("user");
        localStorage.removeItem("accessToken");
        if (window.location.pathname !== "/login" && window.location.pathname !== "/register") {
          window.location.href = "/login";
        }
      }
    }
    return Promise.reject(err);
  }
);

/* ============================================================
   🌐 RESPONSE HANDLER
============================================================ */
const responseBody = (res) => res.data;

/* ============================================================
   🌐 PUBLIC REQUEST METHODS
============================================================ */
const requests = {
  get: (url, config = {}) => instance.get(url, config).then(responseBody),
  post: (url, body = {}, config = {}) =>
    instance.post(url, body, config).then(responseBody),
  put: (url, body = {}, config = {}) =>
    instance.put(url, body, config).then(responseBody),
  patch: (url, body = {}, config = {}) =>
    instance.patch(url, body, config).then(responseBody),
  delete: (url, config = {}) =>
    instance.delete(url, config).then(responseBody),
};

export default requests;
